<template>
  <div class="flex justify-between items-start gap-4">
    <div class="flex flex-col items-start gap-4 flex-1">
      <VBtn
        v-if="!!showButton"
        data-testid="page-header-button"
        class="button-large"
        :class="[{ 'px-0': variant === 'text' }]"
        size="large"
        color="primary"
        prepend-icon="arrow_back"
        :variant="variant"
        @click="emit('back')"
      >
        {{ showButton }}
      </VBtn>

      <div class="flex flex-row justify-between items-center w-full">
        <h2 data-testid="page-header-heading" class="text-h2">
          <slot />
        </h2>

        <slot name="heading-actions" />
      </div>

      <h4 v-if="subHeading" data-testid="page-header-subheading" class="text-h4">
        {{ subHeading }}
      </h4>

      <span
        v-if="!!text"
        data-testid="page-header-text"
        class="text-body-1 text-secondary-text max-w-[800px]"
      >
        {{ text }}
      </span>

      <slot name="details" />
    </div>

    <slot name="actions" />
  </div>
</template>

<script setup lang="ts">
export interface PageHeaderProps {
  showButton?: string
  subHeading?: string
  text?: string
  variant?: 'outlined' | 'text'
}

interface Emits {
  (e: 'back'): void
}

const { showButton, subHeading, text, variant = 'text' } = defineProps<PageHeaderProps>()

const emit = defineEmits<Emits>()
</script>
